import { NormalizedNumber } from '@sparkdotfi/common-universal'
import BigNumber from 'bignumber.js'

import { calculateGemConversionFactor } from '@/features/actions/utils/savings'

export interface CalculateGemMinAmountOutParams {
  gemDecimals: number
  assetsTokenDecimals: number
  assetsAmount: bigint
}

export function calculateGemMinAmountOut({
  gemDecimals,
  assetsTokenDecimals,
  assetsAmount,
}: CalculateGemMinAmountOutParams): bigint {
  const gemConversionFactor = NormalizedNumber(calculateGemConversionFactor({ gemDecimals, assetsTokenDecimals }))
  const gemMinAmountOut = NormalizedNumber(assetsAmount)
    .div(gemConversionFactor)
    .integerValue(BigNumber.ROUND_DOWN)
    .toBaseNumber(0)
  return gemMinAmountOut.toBigInt()
}
